const VIEWS = {
    manager: require('../modules/views/accommodation_map_manager'),
    intermediate: require('../modules/views/accommodation_map_intermediate'),
    fullView: require('../modules/views/accommodation_map_full_view'),
};

function updateWidget(classToUpdate) {
    /* jshint validthis: true */
    this.view.$cachedSelectors.mapDetailsContainer.removeClass('loaded');
    return classToUpdate.update.call(classToUpdate);
}

module.exports = Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_map_manager'),

    beforeConstructView: function() {
        this.viewClass = VIEWS[this.options.viewType];
    },

    init: Odigeo._.noop,

    update: function() {
        return updateWidget.call(this, this.model);
    },

    refresh: function() {
        var classToUpdate = Odigeo._.isEmpty(this.model.attributes) ? this.model : this.view;

        return updateWidget.call(this, classToUpdate);
    },

    reset: function() {
        this.model.clear();
        this.view.isUpdatedOnSearchResults = true;
    },

    toggle: function() {
        this.view.toggle.apply(this.view, arguments);
    },

    open: function() {
        this.view.open.apply(this.view, arguments);
    },

    close: function() {
        this.view.close.apply(this.view, arguments);
    },

    updatePricesAfterRepricing: function(args) {
        this.view.updatePricesAfterRepricing(
            args.accommodationDealKey, args.firstRoomDealPrice, args.cssClass);
    },

    setContainerHeight: function() {
        this.view.setContainerHeight.apply(this.view, arguments);
    },

    setTemplates: function(templates) {
        this.view.tmpls = templates;
    },

    updateInfoBoxOnPreselected: function(preselectedKey) {
        if (!this.view.isUpdatedOnSearchResults && this.view.absConfig.hasTooltipTemplate) {
            this.update()
                .then(Odigeo._.bind(this.view.bindOnResizeMapOpenHotelInfo, this.view, preselectedKey))
                .then(Odigeo._.bind(this.view.bindOnLoadedInfoWindowCenterPosition, this.view));
        }
    },
});
